import { Component, OnInit, Input,ViewChild,TemplateRef,ElementRef, NgZone, QueryList, ViewChildren } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl, FormArray } from '@angular/forms';
import { Location, ApplicationItineraryService, ApplicationService, ProgramService,
  LocationService, TDSDateAdapter, AccountSettingService, 
  GooglePlacesService, TDAccountSetting, RedirectLoginDialogComponent} from '@terradotta/commons';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import * as moment from 'moment';
import { debounceTime } from 'rxjs/operators';
import { MapsAPILoader } from '@agm/core'; 
import { Platform } from '@angular/cdk/platform';
import { DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';

export interface TDLoginApplicationItinerary {
  locationId: any;
  dateUpdated: string;
  programItineraryId: any;
  startDate: string;
  displayLocation: string;
  bDualYearTerm: boolean;
  dateCreated: string;
  endDate: string;
  applicationItineraryId:number;
  city: string;
  country: string;
  region: string;
}

declare var google: any;
declare var $: any;

@Component({
  selector: 'app-application-cycle',
  templateUrl: './application-cycle.component.html',
  styleUrls: ['./application-cycle.component.scss'],
  providers: [{
    provide: DateAdapter,
    useClass: TDSDateAdapter,
    deps: [
      AccountSettingService,
      MAT_DATE_LOCALE,
      Platform]
  }]
})
export class ApplicationCycleComponent implements OnInit {
  @Input() primaryColor: string;
  @Input() redirectURL: string;
  @Input() activeAppCycleResults:any;
  @Input() programId: any;
  @Input() isPreview: boolean = false;
  @Input() userId: number;
  @Input() isISSS: boolean = false;
  
  itineraryForm: FormGroup;
  updateForm: FormGroup;
  programAppCycleForm: FormGroup;
  locations: Location[] = [];
  itineraryState: Map<TDLoginApplicationItinerary,any> = new Map<TDLoginApplicationItinerary,any>();
  showAddItineraryForm: boolean = false;//true
  showEditItineraryButton: boolean = true;
  showDeleteItineraryButton: boolean = true;
  loadingLocation: boolean = false;
  updateLocations: any[] = [];
  loadingUpdateLocation: boolean = false;
  autocomplete: any;
  autocompleteListener: any;
  i18nFields: any = {
    itineraryStartDate: 'Arrival date',
    itineraryEndDate: 'Departure date',
  }
  dateJsonFormat: string = 'YYYY-MM-DDT00:00:00';
  applicationItineraries: TDLoginApplicationItinerary[] = [];
  tempralApplicationItineraries: TDLoginApplicationItinerary[] = [];
  userCreateApplication: boolean;
  noCreateApplicationMsg: string;
  requiresAdvising: boolean = false;
  advisingProgram: any;
  advisingMsg: string;
  requiresItinerary: boolean = false;
  noMatchingLocations: boolean = false;
  googleLocations: any[] = [];
  creatingApplication: boolean = false;
  creatAppErroMsg: string;
  publicAppCycle: boolean = true;
  existingAdvisingApplicationId: number;
  advisingApplicationExists: boolean = false;
  existingAdvisingAppMsg: string = '';
  reasonForDenyingApplication: string = '';
  autoSelectedResult:any;
  cycle:any;
  @ViewChild('removeItineraryDialog') removeItineraryDialog: TemplateRef<any>;
  @ViewChild('redirectProgramDiscoveryDialog') redirectProgramDiscoveryDialog: TemplateRef<any>;
  @ViewChild('googleAttributions',{static:true}) googleAttributions: ElementRef;
  @ViewChildren('locationInput') locationInput: QueryList<ElementRef>;
  @ViewChild('locationUpdateInput') locationUpdateInput: ElementRef;
  isAdvProgram:boolean = false;
  existingApplications: boolean = false;
  angularApplicationUI:boolean = false;

  testForm: FormGroup;
  currentGroup: FormGroup;
  disabledContinueBtn: boolean = true;
  showItineraryAlert: boolean = true;
  loadingLocationArray: boolean[] = [];

  constructor(
    private fb: FormBuilder,
    private _appItineraryService: ApplicationItineraryService,
    private _locationService: LocationService,
    private dialog: MatDialog,
    private _applicationService: ApplicationService,
    private _programService: ProgramService,
    private _googlePlacesService: GooglePlacesService,
    private mapsAPILoader: MapsAPILoader,
    private ngZone: NgZone,
    private snackbar: MatSnackBar,
    private _accountSettingService: AccountSettingService
  ) { 
    this.locationDisplayFn = this.locationDisplayFn.bind(this);
  }

  ngOnInit(){
    this._accountSettingService.getByName('_bEnableAngularApplicantUI').subscribe((resp: TDAccountSetting)=> {
      if(resp){
        this.angularApplicationUI = resp.settingValue
      }
    })
    if(parseInt(this.programId) > 0 && this.activeAppCycleResults === {}){
      this._programService.getApplyAppCycles(this.programId, this.userId).subscribe(data => {
        this.activeAppCycleResults = data;
        this.cycleItineraryReqs();//1
      }, err => {
        if(err.status === 407){///407
          this.dialog.open(RedirectLoginDialogComponent, {
            disableClose: true
          });
        }
      })
    }
    else {      
      this.loadI18n(this.activeAppCycleResults.i18n);
      this.cycleItineraryReqs();//1
    }
    this.existingAdvisingApplicationId = this.activeAppCycleResults.existingAdvisingApplicationId;
    if(this.existingAdvisingApplicationId > 0){
      this.advisingApplicationExists = true;
      this.existingAdvisingAppMsg = 'Advising application exists. Select term to add to Programs of Interest or go to Advising application';//unused
    } 
    else {
      this.advisingApplicationExists = false;
    }
    if(!this.activeAppCycleResults.userCanCreateAdvisingApplication){      
      this.advisingApplicationExists = false;
    }
  }

  addFormGroup(){
    let groups = (this.testForm.get('groups') as FormArray);
    let pos = groups.length;
    groups.push(this.createMainFormGroup(pos));
    this.checkDisableBtn();
  }

  createMainFormGroup(pos){
    var that = this;
    this.loadingLocationArray.push(false);

    const group = new FormGroup({
      'id': new FormControl(pos),
      'location': new FormControl('', Validators.required),
      'googlePlaceSearch': new FormControl(''),
      'locationInput': new FormControl('', Validators.required),
      'startDate': new FormControl('', Validators.required),
      'endDate': new FormControl('', Validators.required),
    });
    group.get('locationInput').valueChanges.pipe(
      debounceTime(600)).subscribe(val => {
        that.currentGroup = group;
        that.subscribeToLocationInput(group, val);
        if(val === ""){
          that.checkDisableBtn(group);
        }
    });
    group.get('startDate').valueChanges.pipe(
      debounceTime(600)).subscribe(val => {
        that.checkDisableBtn(group);
    });
    group.get('endDate').valueChanges.pipe(
      debounceTime(600)).subscribe(val => {
        that.checkDisableBtn(group);
    });
    return group;
  }

  checkDisableBtn(group = null){
    let id = group?.get('id').value;

    if(group) {
      this.updateItineraryDataPos(id);
    }
    if(this.requiresItinerary && !this.isAdvProgram){
      if(this.applicationItineraries?.length == 1){
        let exists = (this.applicationItineraries.some(x => (x.locationId && x.startDate && x.endDate)));
        this.showItineraryAlert = !exists;
      }
      else {
        if(this.testForm?.invalid && this.applicationItineraries?.length > 0){
          let exists = (this.applicationItineraries.some(x => (x.locationId && x.startDate && x.endDate)));
          this.showItineraryAlert = !exists;
        }
        else {
          this.showItineraryAlert = (this.applicationItineraries?.length == 0);
        }
      }
    }
    var temp1 = (this.publicAppCycle && this.programAppCycleForm?.invalid);
    var temp2 = (this.requiresItinerary && this.applicationItineraries?.length === 0);

    if(this.requiresItinerary && !this.isAdvProgram){
      this.disabledContinueBtn = (this.creatingApplication || this.testForm?.invalid || temp1 || temp2);
    }
    else {
      this.disabledContinueBtn = (this.creatingApplication || temp1 || temp2);
    }
  }

  onFocusOutEvent(e, pos){
    let groups = (this.testForm.get('groups') as FormArray).controls;
    let locationControl = groups[pos].get('location').value;

    if(!locationControl){
      groups[pos].get('locationInput').setErrors({ 'invalid': true });
    }
    else {
      groups[pos].get('locationInput').setErrors(null);
    }
    this.checkDisableBtn();
  }

  updateItineraryDataPos(id){
    let groups = (this.testForm.get('groups') as FormArray).controls;
    let pos = groups.findIndex(x => x.get('id').value === id);
    let locationControl = groups[pos].get('location').value;
    let locationInputControl = groups[pos].get('locationInput').value;
    let startDate = groups[pos].get('startDate').value;
    let endDate = groups[pos].get('endDate').value;
    let tempStartDate = (startDate) ? moment(startDate).format('YYYY-MM-DD') : "";
    let tempEndDate = (endDate) ? moment(endDate).format('YYYY-MM-DD') : "";

    if(!this.applicationItineraries[pos]){
      var lId = 0;

      if(!locationInputControl){
        lId = null;
      }
      else if(locationControl?.ID){
        lId = locationControl.ID;
      }
      var location = {
        CITY: (lId) ? locationControl?.CITY : null,
        COUNTRY: (lId) ? locationControl?.COUNTRY: null,
        ID: lId,
        LATITUDE: (lId) ? locationControl?.LATITUDE : null,
        LONGITUDE: (lId) ? locationControl?.LONGITUDE : null,
        REGION: (lId) ? locationControl?.REGION : null
      };
      var newIt: any = {
        locationId: lId,
        location: location,
        city: location.CITY,
        country: location.COUNTRY,
        region: location.REGION,
        displayLocation: this._locationService.formatLocation(location, true),        
        applicationItineraryId: 0,
        programItineraryId: 0,
        startDate: tempStartDate,//startDate,
        endDate: tempEndDate,//endDate,
        bDualYearTerm: 0,
        dateUpdated: (new Date()).toJSON(),
        dateCreated: (new Date()).toJSON()
      };
      this.applicationItineraries.push(newIt);
      //this.tempralApplicationItineraries.push(newIt);
    }
    else {
      var lId = 0;

      if(!locationInputControl){
        lId = null;
      }
      else if(locationControl?.ID){
        lId = locationControl.ID;
      }
      var location = {
        CITY: (lId) ? locationControl?.CITY : null,
        COUNTRY: (lId) ? locationControl?.COUNTRY: null,
        ID: lId,
        LATITUDE: (lId) ? locationControl?.LATITUDE : null,
        LONGITUDE: (lId) ? locationControl?.LONGITUDE : null,
        REGION: (lId) ? locationControl?.REGION : null
      };
      var newIt: any = {
        locationId: lId,
        location: location,
        city: location.CITY,
        country: location.COUNTRY,
        region: location.REGION,
        displayLocation: this._locationService.formatLocation(location, true),        
        applicationItineraryId: 0,
        programItineraryId: 0,
        startDate: tempStartDate,//startDate,
        endDate: tempEndDate,//endDate,
        bDualYearTerm: 0,
        dateUpdated: (new Date()).toJSON(),
        dateCreated: (new Date()).toJSON()
      };
      this.applicationItineraries[pos] = newIt;
      //this.tempralApplicationItineraries[pos] = newIt;
    }
  }

  updateItineraryData(){//unused
    var that = this;
    let groups = (this.testForm.get('groups') as FormArray).controls;
    this.applicationItineraries = [];

    groups.forEach(item => {
      let locationControl = item.get('location').value;
      let startDate = item.get('startDate').value;
      let endDate = item.get('endDate').value;

      var lId = 0;
      if(locationControl.ID){
        lId = locationControl.ID;
      }
      var location = {
        CITY: locationControl.CITY,
        COUNTRY: locationControl.COUNTRY,
        ID: lId,
        LATITUDE: locationControl.LATITUDE,
        LONGITUDE: locationControl.LONGITUDE,
        REGION: locationControl.REGION
      };
      var newIt: any = {
        locationId: lId,
        location: location,
        city: location.CITY,
        country: location.COUNTRY,
        region: location.REGION,
        displayLocation: that._locationService.formatLocation(location, true),        
        applicationItineraryId: 0,
        programItineraryId: 0,
        startDate: startDate,
        endDate: endDate,
        bDualYearTerm: 0,
        dateUpdated: (new Date()).toJSON(),
        dateCreated: (new Date()).toJSON()
      };
      that.applicationItineraries.push(newIt);
    });
  }

  onChangeTerm(e){
    this.checkDisableBtn();
  }

  subscribeToLocationInput(group, val){
    var that = this;
    let id = group?.get('id').value;
    let groups = (this.testForm.get('groups') as FormArray).controls;
    let pos = groups.findIndex(x => x.get('id').value === id);
    let element = this.locationInput.find((item, pos, arr) => (pos === id));

    if((typeof(val) === 'string') && (val !== '')){
      group.patchValue({
        location: null
      });
      that.loadingLocationArray[pos] = true;

      that._locationService.findByKeywords([val]).subscribe((data: Location[]) => {
        that.locations = data;
        that.loadingLocationArray[pos] = false;
        
        if(data.length > 0){
          if(that.autocomplete){
            google.maps.event.removeListener(that.autocompleteListener);
            google.maps.event.clearInstanceListeners(that.autocomplete);
            that.autocomplete = null;
            that.autocompleteListener = null;
            var googleContainer = document.getElementsByClassName("pac-container");
            Array.from(googleContainer).forEach(g => g.parentNode.removeChild(g))
          }
        } 
        else {
          that.locations = [];
          //load Places Autocomplete
          if(!that.autocomplete){
            that.mapsAPILoader.load().then(() => {
              that.autocomplete = new google.maps.places.Autocomplete(element.nativeElement, {
                types: ['(cities)']
              });
              setTimeout(() => { // this will make the execution after the above boolean has changed
                element.nativeElement.focus();
              }, 250);

              //this prevents when click Enter the "Remove Itinerary" action triggers
              google.maps.event.addDomListener(element.nativeElement, 'keydown', function(event) { 
                if (event.keyCode === 13) { 
                    event.preventDefault(); 
                }
              });

              that.autocompleteListener = that.autocomplete.addListener("place_changed", () => {
                that.ngZone.run(() => {
                  //get the place result
                  let place = that.autocomplete.getPlace();
                  //verify result
                  if (place === undefined || place.geometry === undefined || place.geometry === null) {
                    return;
                  }
                  var loc = that._googlePlacesService.getLocationFromPlace(place);
                  that._locationService.findRegionByCountry(loc.COUNTRY).subscribe(resp => {
                    loc.REGION = <string>resp;
                    that._locationService.post(loc).subscribe((resp: Location) => {
                      that.updateGroupLocation(group, resp);
                    },
                    err => {
                      if(err.status === 409){
                        google.maps.event.removeListener(that.autocompleteListener);
                        google.maps.event.clearInstanceListeners(that.autocomplete);
                        that.autocomplete = null;
                        that.autocompleteListener = null;
                        var googleContainer = document.getElementsByClassName("pac-container");
                        Array.from(googleContainer).forEach(g => g.parentNode.removeChild(g));
                        group.get('locationInput').reset();
                        that.snackbar.open('This location already exists in the system.','Dismiss',{
                          duration: 3000,
                          verticalPosition:'bottom'
                        });             
                        element.nativeElement.focus();
                      }
                      else {
                        google.maps.event.removeListener(that.autocompleteListener);
                        google.maps.event.clearInstanceListeners(that.autocomplete);
                        that.autocomplete = null;
                        that.autocompleteListener = null;
                        var googleContainer = document.getElementsByClassName("pac-container");
                        Array.from(googleContainer).forEach(g => g.parentNode.removeChild(g));             
                      }
                    })
                  });
                });
              });
            });
          }
        }
      }, err => {
        that.locations = [];
        that.loadingLocationArray[pos] = false;
      });
    }
    else {
      that.locations = [];
    }
  }

  updateGroupLocation(group, loc){
    group.patchValue({location:loc});
    group.patchValue({locationInput:loc});

    google.maps.event.removeListener(this.autocompleteListener);
    google.maps.event.clearInstanceListeners(this.autocomplete);

    this.autocomplete = null;
    this.autocompleteListener = null;
    var googleContainer = document.getElementsByClassName("pac-container");
    Array.from(googleContainer).forEach(g => g.parentNode.removeChild(g));

    this.checkDisableBtn(group);
  }

  createAppCyclesForm(){
    return this.fb.group({
      tdAppCycle:['', Validators.required]
    });
  }

  createItineraryForm(){
    return this.fb.group({
      location: [null,Validators.required],        
      googlePlaceSearch:[''],
      locationInput: [''],
      startDate: ['',Validators.required],
      endDate: ['',Validators.required]
    });  
  }

  createUpdateItineraryForm(){
    return this.fb.group({
      location: [null,Validators.required],
      locationInput: [''],
      startDate: ['',Validators.required],
      endDate: ['',Validators.required]
    });
  }

  removeFormGroupAtPosition(i: number) {
    const groups = (this.testForm.get('groups') as FormArray).controls;

    if (groups.length > 0 && groups[i]) {
      (this.testForm.get('groups') as FormArray).removeAt(i);
    }
  }

  cycleItineraryReqs(){//2
    var that = this;
    this.advisingProgram = this.activeAppCycleResults.currentAdvisingProgramDetails;
    this.userCreateApplication = this.activeAppCycleResults.userCanCreateApplication;
    this.publicAppCycle = this.activeAppCycleResults.publicAppCycle;
    this.requiresItinerary = this.activeAppCycleResults.createItineraryForApplication;
    this.requiresAdvising = this.activeAppCycleResults.userCanCreateAdvisingApplication;
    this.existingApplications = (this.activeAppCycleResults.existingApplicationData.length > 0);

    if(this.advisingProgram.programId === parseInt(this.programId)){
      this.isAdvProgram = true;
      
      if(!this.existingApplications){
        setTimeout(() => {    
          this.createApplication();//3
        }, 600);
      }
      else{
        this.isISSS = false;
      }
    }
    else {
      if(this.activeAppCycleResults.existingApplicationData.length > 0){
        this.existingApplications = true;
      }
      if(this.activeAppCycleResults.userCanCreateAdvisingApplication){
        //this.requiresAdvising = true;
        this.advisingMsg = 'This program requires the creation of an Advising application. Please click Continue to create your Advising application.';
        if(!this.publicAppCycle){
          this.autoSelectAppCycle();
        }
        if(!this.publicAppCycle && !this.requiresItinerary){
          this.creatingApplication = true;
          this.advisingMsg = 'This program requires the creation of an Advising application.';
          setTimeout(() => {
            this.createApplication();//3
          }, 600);
        }
      }
      else {
        //this.requiresAdvising = false;
        this.advisingApplicationExists = false;
      }
      if(this.activeAppCycleResults.publicAppCycle){
        //this.publicAppCycle = true;
        this.programAppCycleForm = this.createAppCyclesForm();
      }
      else {
        this.publicAppCycle = false;
      }
      // if(!this.activeAppCycleResults.userCanCreateApplication){
      //   this.userCreateApplication = true;
      //   this.noCreateApplicationMsg = 'You are an ineligible applicant type for this application. If you think this is incorrect please contact the office.';
      // }    
      if(this.activeAppCycleResults.createItineraryForApplication){
        //this.requiresItinerary = true;
        this.itineraryForm = this.createItineraryForm();
        this.updateForm = this.createUpdateItineraryForm();
        this.testForm = this.fb.group({
          groups: this.fb.array([])//this.createMainFormGroup(0)])
        });
        this.loadingLocationArray.push(false);
        this.subscribeToLocationChanges();
        this.subscribeToUpdateLocationChanges();
        //this.updateItinerary();
        that._googlePlacesService.setGoogleAttributionsRef(that.googleAttributions);
      }
      if(!this.userCreateApplication && this.activeAppCycleResults?.reasonForDenyingApplication != ''){
        this.reasonForDenyingApplication = "The application request cannot be completed.";
        this.snackbar.open(this.activeAppCycleResults?.reasonForDenyingApplication, 'Dismiss', {
          duration: 13000
        });
      }
      if(!this.publicAppCycle && !this.requiresAdvising){
        this.autoSelectAppCycle();
      }
      if( ( (!this.publicAppCycle && !this.requiresItinerary && !this.requiresAdvising) && (this.advisingProgram.programId !== parseInt(this.programId)) ) ){
          this.creatingApplication = true;
          setTimeout(() => {
            this.createApplication();//3
          }, 600)
      }
    }    
  }

  updateItinerary(){
    var that = this;

    that._appItineraryService.get(0).subscribe((resp: any[]) => {
      var sorted: TDLoginApplicationItinerary[] = resp;
      sorted.sort((a,b) => {
        return moment(a.startDate).toDate().getTime() - moment(b.startDate).toDate().getTime();
      })
      that.applicationItineraries = sorted;
      that.populateItineraryData(that.applicationItineraries);

      that.itineraryState = new Map<TDLoginApplicationItinerary, any>();
      that.applicationItineraries.forEach(itinerary => {
        that.itineraryState.set(itinerary,{
          isEditing: false
        });
      });
    });
  }

  resetForm(){//testing
    this.testForm = this.fb.group({
      groups: this.fb.array([])
    });
    this.applicationItineraries = [];
  }

  populateItineraryData(applicationItineraries){
    let groups = this.testForm.get('groups') as FormArray;

    applicationItineraries.forEach((item, pos, array) => {
      groups.push(this.createMainFormGroup(pos));

      groups.controls[pos]?.patchValue({
        location: item.location,
        locationInput: item.location,
        startDate: item.startDate,
        endDate: item.endDate,
      });
    });
    if(applicationItineraries.length > 0){
      this.checkDisableBtn();
    }
  }

  subscribeToUpdateLocationChanges(){
    var that = this;

    that.updateForm.get('locationInput').valueChanges.pipe(
      debounceTime(600)
    ).subscribe(val => {
      if((typeof(val) === 'string') && (val !== '')){
        that.updateForm.patchValue({
          location: null
        })
        that.loadingUpdateLocation = true;
        that._locationService.findByKeywords([val]).subscribe((data: Location[]) => {
          that.updateLocations = data.map((loc: Location) => {
            return {
              ID: loc.ID,
              displayLocation: that._locationService.formatLocation(loc,true),
              CITY: loc.CITY,
              COUNTRY: loc.COUNTRY,
              LATITUDE: loc.LATITUDE,
              LONGITUDE: loc.LONGITUDE,
              REGION: loc.REGION
            };
          });
          that.loadingUpdateLocation = false;
          if(data.length > 0){
            // that.locations = data.filter((loc: Location) => currentIds.indexOf(loc.ID) < 0);

            if(that.autocomplete){
              google.maps.event.removeListener(that.autocompleteListener);
              google.maps.event.clearInstanceListeners(that.autocomplete);
              that.autocomplete = null;
              that.autocompleteListener = null;
              var googleContainer = document.getElementsByClassName("pac-container");
              Array.from(googleContainer).forEach(g => g.parentNode.removeChild(g))
            }
          } 
          else {
            this.locations = [];
            //load Places Autocomplete
            if(!that.autocomplete){
              that.mapsAPILoader.load().then(() => {
                that.autocomplete = new google.maps.places.Autocomplete(this.locationUpdateInput.nativeElement, {
                  types: ['(cities)']
                });
                setTimeout(()=>{ // this will make the execution after the above boolean has changed
                  //that.locationInput.nativeElement.blur();
                  //that.locationInput.nativeElement.focus();
                }, 250); 
                that.autocompleteListener = that.autocomplete.addListener("place_changed", () => {
                  that.ngZone.run(() => {
                    //get the place result
                    let place = that.autocomplete.getPlace();
                    //verify result
                    if (place === undefined || place.geometry === undefined || place.geometry === null) {
                      return;
                    }
                    var loc = that._googlePlacesService.getLocationFromPlace(place);
                    that._locationService.findRegionByCountry(loc.COUNTRY).subscribe(resp => {
                      loc.REGION = <string>resp;
                      that._locationService.post(loc).subscribe((resp: Location) => {
                        that.updateLocation(resp);
                      },
                      err => {
                        if(err.status === 409){
                          google.maps.event.removeListener(that.autocompleteListener);
                          google.maps.event.clearInstanceListeners(that.autocomplete);
                          that.autocomplete = null;
                          that.autocompleteListener = null;
                          var googleContainer = document.getElementsByClassName("pac-container");
                          Array.from(googleContainer).forEach(g => g.parentNode.removeChild(g))
                          this.updateForm.get('locationInput').reset();
                          this.snackbar.open('This location already exists in the system.','Dismiss',{
                            duration: 3000,
                            verticalPosition:'bottom'
                          });             
                          //this.locationInput.nativeElement.focus();
                          //this.locationInput.nativeElement.blur();
                        } 
                        else {
                          google.maps.event.removeListener(that.autocompleteListener);
                          google.maps.event.clearInstanceListeners(that.autocomplete);
                          that.autocomplete = null;
                          that.autocompleteListener = null;
                          var googleContainer = document.getElementsByClassName("pac-container");
                          Array.from(googleContainer).forEach(g => g.parentNode.removeChild(g))
                          //googleContainer.parentNode.removeChild(googleContainer)                          
                        }
                      })
                    });
                  });
                });
              });
            }
          }
        }, err => {
          that.updateLocations = [];
          that.loadingUpdateLocation = false;
        });
      } 
      else {
        that.updateLocations = [];
      }
    })
  }

  subscribeToLocationChanges(){
    var that = this;
    that.itineraryForm.get('locationInput').valueChanges.pipe(
      debounceTime(600)
    ).subscribe(val => {
      if((typeof(val) === 'string') && (val !== '')){
        that.itineraryForm.patchValue({
          location: null
        });
        that.loadingLocation = true;
        that._locationService.findByKeywords([val]).subscribe((data: Location[]) => {
          that.locations = data;
          that.loadingLocation = false;
          if(data.length > 0){
            // that.locations = data.filter((loc: Location) => currentIds.indexOf(loc.ID) < 0);

            if(that.autocomplete){
              google.maps.event.removeListener(that.autocompleteListener);
              google.maps.event.clearInstanceListeners(that.autocomplete);
              that.autocomplete = null;
              that.autocompleteListener = null;
              var googleContainer = document.getElementsByClassName("pac-container");
              Array.from(googleContainer).forEach(g => g.parentNode.removeChild(g))
            }
          } 
          else {
            that.locations = [];
            //load Places Autocomplete
            if(!that.autocomplete){
              that.mapsAPILoader.load().then(() => {
                // that.autocomplete = new google.maps.places.Autocomplete(this.locationInput.nativeElement, {
                //   types: ['(cities)']
                // });
                setTimeout(() => { // this will make the execution after the above boolean has changed
                  //that.locationInput.nativeElement.blur();
                  //that.locationInput.nativeElement.focus();
                },250); 
                that.autocompleteListener = that.autocomplete.addListener("place_changed", () => {
                  that.ngZone.run(() => {
                    //get the place result
                    let place = that.autocomplete.getPlace();
                    //verify result
                    if (place === undefined || place.geometry === undefined || place.geometry === null) {
                      return;
                    }
                    var loc = that._googlePlacesService.getLocationFromPlace(place);
                    that._locationService.findRegionByCountry(loc.COUNTRY).subscribe(resp => {
                      loc.REGION = <string>resp;
                      that._locationService.post(loc).subscribe((resp: Location) => {
                        that.addLocation(resp);
                      },
                      err => {
                        if(err.status === 409){
                          google.maps.event.removeListener(that.autocompleteListener);
                          google.maps.event.clearInstanceListeners(that.autocomplete);
                          that.autocomplete = null;
                          that.autocompleteListener = null;
                          var googleContainer = document.getElementsByClassName("pac-container");
                          Array.from(googleContainer).forEach(g => g.parentNode.removeChild(g))
                          that.itineraryForm.get('location').reset();  
                          that.snackbar.open('This location already exists in the system.','Dismiss',{
                            duration: 3000,
                            verticalPosition:'bottom'
                          });             
                          //that.locationInput.nativeElement.focus();
                          //that.locationInput.nativeElement.blur();
                        } 
                        else {
                          google.maps.event.removeListener(that.autocompleteListener);
                          google.maps.event.clearInstanceListeners(that.autocomplete);
                          that.autocomplete = null;
                          that.autocompleteListener = null;
                          var googleContainer = document.getElementsByClassName("pac-container");
                          Array.from(googleContainer).forEach(g => g.parentNode.removeChild(g))
                          // googleContainer.parentNode.removeChild(googleContainer)                          
                        }
                      })
                    });
                  });
                });
              });
            }
          }
        }, err => {
          that.locations = [];
          that.loadingLocation = false;
        });
      } else {
        that.locations = [];
      }
    })
  }

  selectedLocation(pos, group, e){
    let groups = (this.testForm.get('groups') as FormArray).controls;
    groups[pos].patchValue({
      location: e.option?.value
    });
    groups[pos].get('locationInput').setErrors(null);
    this.testForm.get('groups').updateValueAndValidity();
    this.checkDisableBtn(group);

    // this.itineraryForm.patchValue({
    //   location: e.option.value
    // });
  }

  updateSelectedLocation(e){//unused
    this.updateForm.patchValue({
      location: e.option.value
    })
  }

  addLocation(loc){
    this.itineraryForm.patchValue({location:loc});
    google.maps.event.removeListener(this.autocompleteListener);
    google.maps.event.clearInstanceListeners(this.autocomplete);
    this.autocomplete = null;
    this.autocompleteListener = null;
    var googleContainer = document.getElementsByClassName("pac-container");
    Array.from(googleContainer).forEach(g => g.parentNode.removeChild(g))
  }

  updateLocation(loc){
    this.updateForm.patchValue({location:loc});
    this.updateForm.patchValue({locationInput:loc});
    google.maps.event.removeListener(this.autocompleteListener);
    google.maps.event.clearInstanceListeners(this.autocomplete);
    this.autocomplete = null;
    this.autocompleteListener = null;
    var googleContainer = document.getElementsByClassName("pac-container");
    Array.from(googleContainer).forEach(g => g.parentNode.removeChild(g))
  }

  locationDisplayFn(location: Location){
    var that = this;
    if(location){
      return that._locationService.formatLocation(location, true);
    } 
    else {
      return '';
    }
  }

  updateLocationDisplayFn(location: any){//unused
    if(location){
      return location.displayLocation;
    } 
    else {
      return '';
    }
  }

  onSubmit(value){//unused
    var that = this;
    that.itineraryForm.reset({
      location: '',
      startDate: '',
      endDate: ''
    });
    that.itineraryForm.get('location').markAsPristine();
    that.itineraryForm.get('location').markAsUntouched();
    that.itineraryForm.get('location').updateValueAndValidity();
    that.itineraryForm.markAsPristine();
    that.itineraryForm.markAsUntouched();
    that.itineraryForm.updateValueAndValidity();
    var lId = 0
    if(value.location.ID){
      lId = value.location.ID
    }
    var location = {
      CITY: value.location.CITY,
      COUNTRY: value.location.COUNTRY,
      ID: lId,
      LATITUDE: value.location.LATITUDE,
      LONGITUDE: value.location.LONGITUDE,
      REGION: value.location.REGION
    };
    var request = {
      applicationItineraryId: 0,
      programItineraryId: 0,
      locationId: value.location.ID,
      startDate: value.startDate,
      endDate: value.endDate,
    };
    var newIt: any = {
      locationId: lId,
      location: location,
      city: value.location.CITY,
      country: value.location.COUNTRY,
      region: value.location.REGION,
      displayLocation: that._locationService.formatLocation(value.location, true),        
      applicationItineraryId: 0,
      programItineraryId: 0,
      startDate: value.startDate,
      endDate: value.endDate,
      bDualYearTerm: 0,
      dateUpdated: (new Date()).toJSON(),
      dateCreated: (new Date()).toJSON()
    };
    that.applicationItineraries.push(newIt);
    that.itineraryState.set(newIt, {});
  }

  onDelete(itinerary: TDLoginApplicationItinerary){//unused
    var that = this;
    that.dialog.open(that.removeItineraryDialog,{
      panelClass: 'custom-overlay-pane-class',
      width:'40%',
    }).afterClosed().subscribe(resp => {
      if(resp){
        that.applicationItineraries = that.applicationItineraries.filter(it => it !== itinerary);
      }
    });
  }

  onDeleteItinerary(pos){
    var that = this;
    that.dialog.open(that.removeItineraryDialog,{
      panelClass: 'custom-overlay-pane-class',
      width:'40%',
    }).afterClosed().subscribe(resp => {
      if(resp){
        that.removeFormGroupAtPosition(pos);
        that.applicationItineraries = that.applicationItineraries.filter(it => it !== that.applicationItineraries[pos]);
        that.checkDisableBtn();
      }
    });
  }

  onEdit(itinerary: TDLoginApplicationItinerary){//unused
    var loc: any = {
      ID: itinerary.locationId,
      displayLocation: itinerary.displayLocation,
      CITY:itinerary.city,
      COUNTRY:itinerary.country,
      REGION:itinerary.region
    };
    this.updateLocations = [loc];
    this.updateForm.patchValue({
      location: loc,
      locationInput: loc,
      startDate: moment(itinerary.startDate).toDate(),
      endDate: moment(itinerary.endDate).toDate()
    });
    var state = this.itineraryState.get(itinerary);
    if(state){
      state.isEditing = true;
    }
  }

  onSubmitItinerary(itinerary: TDLoginApplicationItinerary){//unused
    var that = this;
    var request = {
      location: that.updateForm.get('locationInput').value,
      startDate: moment(that.updateForm.get('startDate').value).format(that.dateJsonFormat),
      endDate: moment(that.updateForm.get('endDate').value).format(that.dateJsonFormat),
      locationId: that.updateForm.get('locationInput').value.ID,
        city: that.updateForm.get('locationInput').value.CITY,
        country: that.updateForm.get('locationInput').value.COUNTRY,
        region: that.updateForm.get('locationInput').value.REGION,
        displayLocation: that._locationService.formatLocation(that.updateForm.get('locationInput').value,true),        
        applicationItineraryId: 0,
        programItineraryId: 0,
        bDualYearTerm: false,
        dateUpdated: (new Date()).toJSON(),
        dateCreated: (new Date()).toJSON()
    }
    var updateItinerary = Object.assign(itinerary,request);
    var it = that.itineraryState.get(updateItinerary);
    if(it){
      it.isEditing = false;
    }
  }

  loadI18n(i18n: any[]){
    i18n.forEach(item => {
      switch(item.id){
        case 10264:
          this.i18nFields.itineraryStartDate = item.word;
        break;
        case 10265:
          this.i18nFields.itineraryEndDate = item.word;
        break;
        case 10149:
          this.i18nFields.selectProgramOption = item.word;
        break;
        case 10150:
          this.i18nFields.existingApplications = item.word;
        break;
      }
    });
  }

  autoSelectAppCycle(){
    var ac = this.activeAppCycleResults.appCycleInfo;
    var now = new Date().getTime();

    const closest = ac.reduce((a, b) => new Date(a.applicationDeadline).getTime() - now < new Date(b.applicationDeadline).getTime() - now ? a : b);
    this.autoSelectedResult = closest;
  }

  createApplication(){//4
    this.creatingApplication = true;
    this.checkDisableBtn();

    if(this.requiresAdvising || this.isAdvProgram ){
      if(this.advisingProgram === {}){
        this.cycle = {
          year: "",
          programId: "",
          userId: this.userId,
          term: "",      
        }
      } 
      else {
        this.cycle = {
          year: this.advisingProgram.numericYear,//year
          programId: this.advisingProgram.programId,
          userId: this.userId,
          term: this.advisingProgram.term,     
          routingProgramId: parseInt(this.programId) 
        }
      } 
    }
    else if(!this.publicAppCycle && !this.requiresAdvising){
      this.cycle = {
        year: this.autoSelectedResult.numericYear,//year
        programId: parseInt(this.programId),
        userId: this.userId,
        term: this.autoSelectedResult.term,     
      }
    } 
    else if(this.publicAppCycle && !this.requiresAdvising) {
      var termForm = this.programAppCycleForm.get('tdAppCycle').value;
      this.cycle = {
        year: termForm.numericYear,//year
        programId: parseInt(this.programId),
        userId: this.userId,
        term: termForm.term,      
      }
    }
    let appItineraries = {
      createItineraryForApplication: this.activeAppCycleResults.createItineraryForApplication,
      applicationItineraries: this.applicationItineraries
    };
   
    let createApp = Object.assign(this.cycle, appItineraries);
    this._applicationService.createV3Application(createApp).subscribe(resp => {
      if(this.advisingProgram !== {} && (parseInt(this.programId) !== createApp.programId)){
        let termForm = null;
        let poi = {};
        if(this.programAppCycleForm){
          termForm = this.programAppCycleForm.get('tdAppCycle').value;
          poi = {
            advisingApplicationId: resp.applicationId,
            programOfInterestId: parseInt(this.programId),
            programOfInterestTerm: termForm.term, 
            programOfInterestYear: termForm.numericYear,//year
            adminApproved: false
          };
        }
        else{
          poi = {
            advisingApplicationId: resp.applicationId,
            programOfInterestId: parseInt(this.programId),
            programOfInterestTerm: this.autoSelectedResult.term, 
            programOfInterestYear: this.autoSelectedResult.numericYear,//year
            adminApproved: false
          };
        }
        this._applicationService.addProgramsOfInterest(resp.applicationId, poi).subscribe(res => {
          window.location.href = window.location.origin + '/index.cfm?FuseAction=Students.Application&Application_ID=' + resp.applicationId;
          setTimeout(() => {
            this.creatingApplication = false;  
          }, 3000);
        }, err => {
          if(err.status === 407){///407
            this.dialog.open(RedirectLoginDialogComponent, {
              disableClose: true
            });
          }
        })
      } 
      else {
        window.location.href = window.location.origin + '/index.cfm?FuseAction=Students.Application&Application_ID=' + resp.applicationId;
        setTimeout(() => {
          this.creatingApplication = false;  
        }, 3000);
      }
      this.creatAppErroMsg = null;
    }, err => {
      if(err.status === 407){///407
        this.dialog.open(RedirectLoginDialogComponent, {
          disableClose: true
        });
      }
      else if(err.status === 403){
        this.creatingApplication = false;
        let errMsg: string = 'You have already applied for the maximum number of programs for this app cycle. To apply to additional programs for the selected term & year, you must first withdraw from another application within the same term and year. Alternatively, you may choose a different term/year combination (if available)';      
        this.creatAppErroMsg = "The application request cannot be completed.";
        this.snackbar.open(errMsg, 'Dismiss', {
          duration: 10000
        });
      }
      else if(err.status === 412){
        this.dialog.open(this.redirectProgramDiscoveryDialog, {
          data: {
            message: "The application for the advising program cannot be created because there is not an application cycle available for it."
          },
          disableClose: true,
          panelClass: 'custom-overlay-pane-class',
          width:'40%',
        }).afterClosed().subscribe(resp => {
          window.location.href = window.location.origin + '/index.cfm?FuseAction=Programs.ProgramDiscovery';
          setTimeout(() => {
            this.creatingApplication = false;  
          }, 3000);
        });
      }
    })      
  }

  cancelApplication(){
    window.location.href = window.location.origin + '/index.cfm?FuseAction=Portal.Home';
  }

  goToExistingApplication(){
    window.location.href = window.location.origin + '/index.cfm?FuseAction=Students.Application&Application_ID=' + this.existingAdvisingApplicationId;
  }

  addProgramOfInterest(){
    this.creatingApplication = true;
    let termForm = null;
    let poi = {};
    if(this.programAppCycleForm){
      termForm = this.programAppCycleForm.get('tdAppCycle').value;
      poi = {
        advisingApplicationId: this.existingAdvisingApplicationId,
        programOfInterestId: parseInt(this.programId),
        programOfInterestTerm: termForm.term, 
        programOfInterestYear: termForm.numericYear,//year
        adminApproved: false
      };
    }
    else{
      poi = {
        advisingApplicationId: this.existingAdvisingApplicationId,
        programOfInterestId: parseInt(this.programId),
        programOfInterestTerm: this.autoSelectedResult.term, 
        programOfInterestYear: this.autoSelectedResult.numericYear,//year
        adminApproved: false
      };
    }
    this._applicationService.addProgramsOfInterest(this.existingAdvisingApplicationId, poi).subscribe(res =>{
      window.location.href = window.location.origin + '/index.cfm?FuseAction=Students.Application&Application_ID=' + this.existingAdvisingApplicationId
    }, err => {
      this.creatingApplication = false;
      if(err.status === 407){///407
        this.dialog.open(RedirectLoginDialogComponent, {
          disableClose: true
        });
      }
    });
  }
}